import { NavDropdown } from 'react-bootstrap';
import { useTheme, Theme, THEMES } from 'utils/contexts/ThemeProvider';

const ThemeSelector = () => {
  const { theme, setTheme } = useTheme();

  const handleThemeChange = (newTheme: Theme) => {
    setTheme(newTheme);
  };

  return (
    <>
      <NavDropdown.Header>Tema</NavDropdown.Header>
      {THEMES.map((t) => (
        <NavDropdown.Item
          key={t.id}
          onClick={() => handleThemeChange(t.id)}
          active={theme === t.id}
        >
          {t.icon} {t.label}
        </NavDropdown.Item>
      ))}
    </>
  );
};

export default ThemeSelector;
